const resolveEnv = (paths) => {
  const hostname = window.location.hostname

  if (!paths || !paths.localhost || !paths.ist || !paths.uat || !paths.prod) {
    throw Error(
      'The parameter must have the following format {"localhost":"","ist":"","uat":"","prod":""}'
    )
  }

  if (hostname.includes('localhost')) {
    return paths.localhost
  }

  if (hostname.includes('ist')) {
    return paths.ist
  }

  if (hostname.includes('uat')) {
    return paths.uat
  }

  return paths.prod
}

export default resolveEnv
